import { FC } from 'react';
import { QuantityDetailsProps } from './types';

import styles from './QuantityDetails.module.scss';
import { Skeleton } from 'antd';
import {FlipNumber} from "../flip-value/flip-value.ui.tsx";

const QuantityDetails: FC<QuantityDetailsProps> = ({ loading, icon, backgroundColor, title, value, bgIcon, bgIconPosition = {} }) => {
    return (
        <>
            <div
                className={styles.QuantityDetails}
                style={{ background: backgroundColor }}>
                {loading ? (
                    <Skeleton.Node
                        active
                        style={{ height: ' 88px', width: '100%', borderRadius: '10px' }}
                    />
                ) : (
                    <>
                        <div className={styles.value}>
                            <img
                                src={icon}
                                alt=""
                            />
                            <FlipNumber value={value}/>
                        </div>
                        <div className={styles.title}>
                            <h3>{title}</h3>
                        </div>
                        {bgIcon && (
                            <img
                                style={{ ...bgIconPosition }}
                                src={bgIcon}
                                alt=""
                                className={styles.bgIcon}
                            />
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default QuantityDetails;
